import { all, takeEvery, fork, put, select, call } from 'redux-saga/effects'
import actions from './actions'

// api 
import { getListReportsByTier } from '../../services/apis/MultitierServices'

function* saga_LoadListReport(action) {
    try {
        const { params } = action.payload

        let tier_created = yield select(state => state.component_select_report.tier_created)
        let page_size = yield select(state => state.component_select_report.pageSize)
        let page_number = yield select(state => state.component_select_report.pageIndex)
        let status = 'Existed'
        let textSearch = yield select(state => state.component_select_report.lastTextSearch)

        if (params.tier_created) tier_created = params.tier_created
        if (params.page_number) page_number = params.page_number
        if (params.page_size) page_size = params.page_size
        if (params.textSearch) textSearch = params.textSearch
        console.log('tier_created', tier_created)
        if (tier_created === 3) {
            page_size = page_size / 2
        }
        let lstReport = []
        let totalData = 0
        if (tier_created === 3) {
            const responseFromTier1 = yield call(
                getListReportsByTier,
                tier_created - 2,
                page_number,
                page_size,
                status,
                textSearch
            )
            console.log('responseFromTier1', responseFromTier1)
            if (responseFromTier1.error.code === 200 || responseFromTier1.error.code === 309) {
                let reports = responseFromTier1.data
                let total = responseFromTier1.total

                if (reports.length > page_size) reports = reports.slice(0, page_size)
                lstReport = lstReport.concat(reports)
                totalData = totalData + total

            }
        }
        const response = yield call(
            getListReportsByTier,
            tier_created - 1,
            page_number,
            page_size,
            status,
            textSearch
        )

        if (response.error.code === 200 || response.error.code === 309) {
            let reports = response.data
            let total = response.total

            if (reports.length > page_size) reports = reports.slice(0, page_size)
            lstReport = lstReport.concat(reports)
            totalData = totalData + total
            console.log('totalData', totalData)
            yield put(actions.action.loadListReportSuccess(lstReport))
            yield put(actions.action.updateState({
                total: totalData
            }))
        }
        else {
            yield put(actions.action.loadListReportSuccess([]))
            yield put(actions.action.updateState({
                total: 0
            }))
            console.log("Component select report call API erorr ", response.error.message)

        }

    }
    catch (ex) {
        console.log("Component select report - Load list report error : ", ex.message)
    }
}

function* saga_ChangePageSize(action) {
    try {
        const { pageSize } = action.payload
        yield put(actions.action.loadListReport({ page_size: pageSize }))
    }
    catch (ex) {
        console.log("Component select report -  Change current page error ", ex.message)
    }
}

function* saga_ChangeCurrentPage(action) {
    try {
        const { pageIndex } = action.payload
        yield put(actions.action.loadListReport({ page_number: pageIndex }))
    }
    catch (ex) {
        console.log("Component select report - change page size error : ", ex.message)
    }
}

function* saga_SearchReport(action) {
    try {
        const { textSearch } = action.payload
        yield put(actions.action.loadListReport({ textSearch }))
    }
    catch (ex) {
        console.log("Component select report - search report error : ", ex.message)
    }
}

function* saga_UpdateTierCreated(action) {
    try {
        const { tier_created } = action.payload
        yield put(
            actions.action.loadListReport({ tier_created })
        )
    }
    catch (ex) {
        console.log("Component select report - update tier created error : ", ex.message)
    }
}

function* listen() {
    yield takeEvery(actions.type.LOAD_LIST_REPORT, saga_LoadListReport)
    yield takeEvery(actions.type.CHANGE_CURRENT_PAGE, saga_ChangeCurrentPage)
    yield takeEvery(actions.type.CHANGE_PAGE_SIZE, saga_ChangePageSize)
    yield takeEvery(actions.type.SEARCH_REPORT, saga_SearchReport)
    yield takeEvery(actions.type.UPDATE_TIER_CREATED, saga_UpdateTierCreated)
}

export default function* componentSelectReportSaga() {
    yield all([fork(listen)])
}